import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom'; // <-- Переименовали импорт
import Home from '../Pages/Home';
import ReadToken from '../Components/ReadToken';
import ReadLink from '../Components/ReadLink';
import ReadLinkPublic from '../Components/ReadLinkPublic';
import Callback from '../callback';
import Refresh from '../refresh';
import Auth from '../Pages/Auth';
import ReadCompanies from '../Components/ReadCompanies';

const PageNotFound = () => <div>Page not found123</div>;

const AppRoutes = () => (
  // <-- Изменили название компонента
  <RouterRoutes>
    {' '}
    {/* <-- Используем переименованный `Routes` из react-router-dom */}
    <Route path="/" element={<Home />} />
    <Route path="/auth" element={<Auth />} />
    <Route path="/callback.html" element={<Callback />} />
    <Route path="/updatetoken.html" element={<Refresh />} />
    <Route path="/app" element={<ReadToken />} />
    <Route path="/web/project" element={<ReadLink />} />
    <Route path="/web/public" element={<ReadLinkPublic />} />
    <Route path="/companies" element={<ReadCompanies />} />
    <Route path="*" element={<PageNotFound />} />{' '}
    {/* <-- "*" заменяет `component={PageNotFound}` */}
  </RouterRoutes>
);

export default AppRoutes;
